import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import requestPreSignedUrl from "../../Services/requestPreSignedUrlAws";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import MenuPastas from "../../Componentes/ListaPastas/menuPastas";
import FileExplorer from "../../Componentes/ListaPastas";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import "./styles.css";
import useBlockBackNavigation from "./Block";

const Pastas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { IDCliente } = useParams();
  const { IDProcesso } = useParams();
  const { IDPastaPai } = useParams();

  const [Pastas, setPastas] = useState([]);
  const [Arquivos, setArquivos] = useState([]);
  const [clienteLogado, setclienteLogado] = useState();
  const [pilhaPastas, setPilhaPastas] = useState([]);
  const [pastaAtual, setPastaAtual] = useState(IDPastaPai ?? 0);

  const { objClienteAberto, objPastaAberta, setIDPastaAberta, bucketAberto } = usePentagovContext();
  const { authReady } = useAuthContext();
  const { IDOperador, nome, permissaoPrincipal, operador, cargos } = useOperador();

  useBlockBackNavigation(() => {
    if (pilhaPastas.length > 0) {
      const novaPilha = [...pilhaPastas];
      const ultimaPasta = novaPilha.pop();
      setPilhaPastas(novaPilha);
      carregarConteudo(ultimaPasta, IDProcesso, false); // Não adiciona na pilha novamente
    } else {
      console.log("Pilha vazia. Não há pasta anterior.");
    }
  });

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setclienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  const carregarConteudo = async (IDPasta, IDProcesso, adicionarNaPilha = true) => {
    //console.log("pilhaCarrg: ", pilhaPastas);
    try {
      if (adicionarNaPilha && pastaAtual !== null && pastaAtual !== undefined) {
        setPilhaPastas((prev) => [...prev, pastaAtual]);
      }

      let response1 = await buscaPastas(IDPasta, IDProcesso);
      let response2 = await buscaArquivosPorPasta(IDPasta);

      setPastas(response1);
      setArquivos(response2);
      setPastaAtual(IDPasta); // Atualiza pasta atual
      setIDPastaAberta(IDPasta); // Atualiza a pasta aberta no contexto
    } catch (error) {
      console.error("Erro ao carregar conteúdo:", error);
      setPastas([]);
      setArquivos([]);
      setIDPastaAberta(null);
      alert("Houve um problema ao carregar os dados. Por favor, tente novamente mais tarde.");
    }
  };

  async function buscaPastas(IDPasta, IDProcesso) {
    try {
      const idsCargos = cargos?.map((cargo) => cargo.IDCargo).filter(Boolean);
      const params = idsCargos?.length
        ? { IDCargos: idsCargos.join(",") }
        : IDOperador
          ? { IDOperador }
          : {};

      const response = await api.get('/diretorioByIDPai/' + IDPasta + '/' + IDProcesso, { params });
      //console.log( response.data.diretorios);
      return response.data.diretorios;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function buscaArquivosPorPasta(IDPasta) {
    try {
      const response = await api.get('/arquivoByIDPasta/' + IDPasta);
      return response.data.arquivos;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function buscaArquivosPorID(IDArquivo) {
    try {
      const response = await api.get('/arquivo/' + IDArquivo);
      return response.data.Arquivo;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const abrirArquivo = async (IDArquivo) => {
    const arquivo = await buscaArquivosPorID(IDArquivo);
    if (!arquivo) {
      alert("Arquivo não encontrado.");
      return;
    }
    //Requisita o URL pré-assinado para acessar o arquivo
    //attachment = força download do arquivo ao inves de abrir no navegador
    const urlArquivo = await requestPreSignedUrl(permissaoPrincipal, 'getObject', bucketAberto, arquivo.caminho, arquivo.nome, "attachment");
    if (!urlArquivo) {
      alert("Não foi possível obter o URL do arquivo.");
      return;
    }
    console.log("URL do arquivo:", urlArquivo);

    window.open(urlArquivo, "_blank");
  };

  useEffect(function () {
    if (!operador && !authReady) {
      navigate("/");
    }
    carregarConteudo(IDPastaPai, IDProcesso, IDPastaPai);
  }, []);

  const handleBotaoVoltar = () => {
    if (pilhaPastas.length > 0) {
      const novaPilha = [...pilhaPastas];
      const ultimaPasta = novaPilha.pop();

      if (ultimaPasta === '0') {
        setPilhaPastas([]);
      }
      else {
        setPilhaPastas(novaPilha);
      }
      carregarConteudo(ultimaPasta, IDProcesso, false); // Não adiciona na pilha
    } else {
      navigate(`/Servicos/${objClienteAberto.IDCliente}`);
      //alert("Não há pasta anterior para voltar.");
    }
  }


  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={String(IDOperador).padStart(6, '0')} userName={nome} cliente={clienteLogado} />

        <FileExplorer
          diretorios={Pastas}
          arquivos={Arquivos}
          carregarConteudo={carregarConteudo}
          abrirArquivo={abrirArquivo}
          IDProcesso={IDProcesso}
          pastaAtual={pastaAtual}
        />

        <MenuPastas onClickBotaoVoltar={handleBotaoVoltar}
          carregarConteudo={carregarConteudo}
          IDProcesso={IDProcesso}
          IDPastaPai={pastaAtual} />

      </div>
    </div>

  );
};

export default Pastas;
